import { render, staticRenderFns } from "./jobWelfare.vue?vue&type=template&id=3807d401&scoped=true"
import script from "./jobWelfare.vue?vue&type=script&lang=js"
export * from "./jobWelfare.vue?vue&type=script&lang=js"
import style0 from "./jobWelfare.vue?vue&type=style&index=0&id=3807d401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807d401",
  null
  
)

export default component.exports